//数组去重
Array.prototype.uniq = function () {
	let temp = []
	this.forEach(i => {
		if(!temp.includes(i)){
			temp.push(i)
		}
	})
	return temp
};



// WEBPACK FOOTER //
// ./src/util/arrayUtil.js